window._ = require('lodash');
window.Popper = require('popper.js').default;
import cookie from 'vue-cookies';

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

//try {
//    window.$ = window.jQuery = require('jquery');
//
//    require('bootstrap');
//} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

window.axios.interceptors.response.use(function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    return response;
}, function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    if(error.response.status === 401) {
        cookie.remove('access_token');
        window.location.href = "/login";
    }
    return Promise.reject(error);
});

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */


let token = document.head.querySelector('meta[name="csrf-token"]');
let access_token = cookie.get('access_token') ?? null;

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
    if (access_token) {
        window.axios.defaults.headers.common['Authorization'] = `Bearer ${ access_token }`
    }
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

import Echo from 'laravel-echo'

window.Pusher = require('pusher-js');

window.Echo = new Echo({
    broadcaster: 'pusher',
	key: process.env.MIX_PUSHER_APP_KEY,
	cluster: process.env.MIX_PUSHER_APP_CLUSTER,
	encrypted: true,
    auth: {
        headers: {
            Authorization: "Bearer " + access_token
        }
    }
});
